import React from 'react';
import { Modal } from 'antd';
import { Text, Box, Flex } from '../../../shared/components';
import crearPacienteSVG from '../../assets/img/Nuevo Cliente.svg';
import buscarPacienteSVG from '../../assets/img/Buscar Clientes.svg';

export default class BuscarPacienteModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  show() {
    this.setState({ visible: true });
  }

  hide() {
    this.setState({
      visible: false,
    });
  }

  render() {
    const { visible } = this.state;
    const { history, encargoUUID } = this.props;
    return (
      <Modal
        width="fit-content"
        title={(
          <Box>
            <Box><Text fontSize="20" fontWeight="600" translationId="encargos.anyadir_cliente" /></Box>
            <Box><Text fontSize="14" color="#777572">Subtitulo</Text></Box>
          </Box>
        )}
        visible={visible}
        onCancel={() => this.hide()}
        okButtonProps={{ style: { display: 'none' } }}
        cancelText="Cancelar"
      >
        <Flex>
          <Flex p="16px" border="1px solid #D9D9D9" justifyContent="space-between" alignItems="center" flexDirection="column" mr="16px" onClick={() => history.push(`encargo/${encargoUUID}/seleccionarPaciente`)} width="288px" height="198px">
            <Flex height="100%" justifyContent="center" alignItems="center"><img src={buscarPacienteSVG} alt="BuscarPaciente" /></Flex>
            <Text translationId="encargos.buscar_cliente" />
          </Flex>
          <Flex p="16px" border="1px solid #D9D9D9" justifyContent="space-between" alignItems="center" flexDirection="column" onClick={() => history.push(`encargo/${encargoUUID}/pacientes/crear`)} width="288px" height="198px">
            <Flex height="100%" justifyContent="center" alignItems="center"><img src={crearPacienteSVG} alt="Crear Paciente" /></Flex>
            <Text translationId="encargos.nuevo_cliente" />
          </Flex>
        </Flex>
      </Modal>
    );
  }
}

BuscarPacienteModal.propTypes = {
};

BuscarPacienteModal.defaultProps = {
};
